module.exports = __webpack_public_path__ + "img/cat-beverages.60351c9e.webp";